import React from 'react';
import TruckIcon from '../components/common/icons/truckIcon';
import PointsIcon from '../components/common/icons/PointsIcon';
import CalendarIcon from '../components/common/icons/calendarIcon';
import ParkingIcon from '../components/common/icons/ParkingIcon';
import RestofansIcon from '../components/common/icons/RestofansIcon';
import GiftcardIcon from '../components/common/icons/GiftcardIcon';
import MainTheme from '../muiTheme';

let IconMapper = new Map();
IconMapper.set(
  'DESPACHO COSTO $0',
  <TruckIcon size="23px" color={MainTheme.palette.primary.main} />,
);
IconMapper.set(
  'DESPACHO GO',
  <PointsIcon size="23px" color={MainTheme.palette.primary.main} />,
);
IconMapper.set(
  'VIGENCIA PUNTOS GO',
  <CalendarIcon size="23px" color={MainTheme.palette.primary.main} />,
);
IconMapper.set(
  'ESTACIONAMIENTO GRATIS',
  <ParkingIcon size="23px" color={MainTheme.palette.primary.main} />,
);
IconMapper.set(
  'RESTOFANS',
  <RestofansIcon size="23px" color={MainTheme.palette.primary.main} />,
);
IconMapper.set(
  'MANTENCIÓN COSTO $0',
  <GiftcardIcon size="23px" color={MainTheme.palette.primary.main} />,
);

export default IconMapper;
